import { autoinject } from "aurelia-dependency-injection";
import { BrowseView } from "../old-browse/views/browse";
import { BrowseModel } from "../old-browse/models/browse";
import { MasterView } from "../shared/views/master-view";
require("./styles/browse.less");

@autoinject
export class OldBrowseModule extends Backbone.Model {
    constructor(
        private browseView: BrowseView,
        public browseModel: BrowseModel,
        private masterView: MasterView) {
        super();
        this.setupViews();
    }

    public hide() {
        $("#viewport-content").removeClass("old-browse");
        $("#viewport-content").removeClass("old-browse-ready");
    }

    public show(parameters: string) {
        let params = [];
        this.showModule();

        if (parameters) {
            params = parameters.split("/").filter((item) => item.length > 0);
        } else {
            if (this.browseModel.Panels.length > 1) {
                this.browseModel.Panels.forEach((e) => {
                    if (!isNaN(e.Value)) {
                        params.push("category_" + e.Value);
                    }
                });
                params.push("category");
                const url = "browse/" + params.join("/");
                Backbone.history.navigate(url, {trigger: false});
            }
            else {
                params.push("category");
            }
        }

        this.browseModel.setupPanels(params);
        this.browseView.panelsChanged();
    }

    public reset(): void {
       this.browseModel.Panels.remove(this.browseModel.Panels.rest(0));
    }

    private setupViews() {
        this.listenToOnce(this.masterView, "show", () => {
            const browseRegion = this.masterView.addRegion("oldBrowseRegion", "#old-browse-region");
            browseRegion.show(this.browseView);
        });
    }

    private showModule() {
        if (!$("#viewport-content").hasClass("old-browse")) {
            $("#viewport-content").addClass("old-browse");
            setTimeout(() => {
                $("#viewport-content").addClass("old-browse-ready");
            }, 820);
        } else {
            $("#viewport-content").addClass("old-browse-ready");
        }
        const oldBrowseRegion = this.masterView.getRegion("oldBrowseRegion");
        const newBrowseRegion = this.masterView.getRegion("browseRegion");
        $(oldBrowseRegion.el).show();
        if (oldBrowseRegion.el) {
            this.browseView.$el.show();
            $(oldBrowseRegion.el).removeClass("vanish");
            $(newBrowseRegion.el).hide();
        }
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/old-browse/browse-module.ts